<div
  *ngIf="isLoading"
  class="d-flex flex-col flex-wrap align-items-center justify-content-center"
>
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  <p>Cargando Plato...</p>
</div>

<mat-card class="cardWithShadow" *ngIf="!isLoading">
  <mat-card-content style="padding: 36px 36px 0px 36px">
    <h2
      style="font-weight: 600; line-height: 32px; color: #111827"
      mat-dialog-title
    >
      Detalle de Plato
    </h2>
  </mat-card-content>
  <div class="container">
    <mat-card>
      <mat-card-content>
        <form [formGroup]="dishForm">
          <div
            formGroupName="dish"
            style="
              display: flex;
              flex-wrap: wrap;
              justify-content: center;
              gap: 1rem;
            "
          >
            <div style="display: flex; flex-direction: column">
              <mat-form-field appearance="outline">
                <mat-label>Nombre</mat-label>
                <input
                  matInput
                  placeholder="Nombre"
                  formControlName="nombre"
                  name="nombre"
                  required
                  [readonly]="isReadOnly"
                />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Categoría</mat-label>
                <input
                  matInput
                  placeholder="Categoría"
                  formControlName="categoria"
                  name="categoria"
                  required
                  [readonly]="isReadOnly"
                />
              </mat-form-field>
            </div>

            <div>
              <mat-form-field appearance="outline">
                <mat-label>Observaciones</mat-label>
                <textarea
                  matInput
                  placeholder="Observaciones"
                  formControlName="observaciones"
                  name="observaciones"
                  readonly
                  cols="40"
                  rows="6"
                  [readonly]="isReadOnly"
                ></textarea>
              </mat-form-field>
            </div>
          </div>

          <div style="display: flex; flex-wrap: wrap; justify-content: center">
            <button mat-raised-button color="primary" (click)="updatePlato()">
              {{ this.buttonTitle }}
            </button>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>

  <mat-card-content
    [style.display]="insumos && insumos.length > 0"
    style="padding: 36px"
  >
    <div class="row">
      <button mat-raised-button color="primary" (click)="openDialogAdd()">
        Agregar Insumo
      </button>
    </div>
    <div class="table-responsive">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        class="mat-elevation-z8"
        style="margin-top: 2%"
      >
        <ng-container matColumnDef="nombreInsumo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
          <td mat-cell *matCellDef="let element">{{ element.nombreInsumo }}</td>
        </ng-container>

        <ng-container matColumnDef="cantidad">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Cantidad</th>
          <td mat-cell *matCellDef="let element">{{ element.cantidad }}</td>
        </ng-container>

        <ng-container matColumnDef="unidadMedida">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Unidad de Medidad
          </th>
          <td mat-cell *matCellDef="let element">{{ element.unidadMedida }}</td>
        </ng-container>

        <ng-container matColumnDef="eliminar">
          <th mat-header-cell *matHeaderCellDef>Eliminar</th>
          <td mat-cell *matCellDef="let element; let i = index">
            <button mat-icon-button (click)="deleteInsumo(i)">
              <mat-icon class="icon-color">delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <div [hidden]="(insumos && insumos.length === 0) || insumos === null">
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
      </mat-paginator>
    </div>
  </mat-card-content>
</mat-card>
